import { gql } from '@apollo/client'
import { HEALTH_DATA_REPORT_FIELDS } from '@screens/Nora/graphql/fragments/health_data_report.ts'

export const UPDATE_HEALTH_DATA_REPORT_READ_AT = gql`
  ${HEALTH_DATA_REPORT_FIELDS}
  mutation updateHealthDataReportReadAt($id: ID!) {
    updateHealthDataReportReadAt(id: $id) {
      ...HealthDataReportFields
    }
  }
`
